<template>
  <div class="modal-bottom product-page" v-if="item">
    <h6 class="qty-title">{{ _T('quantity') }}</h6>
      <qty-box :qty="item.quantity || 1" :index="item.index"></qty-box>
      <a
        href="javascript:void(0)"
        v-if="addToCartAction"
        data-dismiss="modal"
        @click="addToItem"
        class="btn btn-solid d-none d-lg-block"
      >
        <svg fill="none" width="14" height="12">
          <use xlink:href="#cartW" />
        </svg>
        {{ _T(addToCartAction) }}
      </a>
      <a
        href="javascript:void(0)"
        v-else
        data-dismiss="modal"
        @click="addToCart"
        class="btn btn-solid"
      >
        <svg fill="none" width="14" height="12">
          <use xlink:href="#cartW" />
        </svg>
        {{ _T('add to cart') }}
      </a>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { isObjectEmpty } from '@/utils/main_utils'
import { mapGetters, mapActions, mapState } from 'vuex'
import QtyBox from "@/components/Blocks/Cart/QtyBox";
export default {
  data() {
    return {
      errors: {},
    }
  },
  computed: {
    ...mapState({
      item: state => state.cart_store.selectedItem,
    }),
    ...mapGetters([
      '_T_DB',
      '_T',
      'selected_modifiers',
      'itemModifierGroups',
      'itemModifierSubgroupsByGroup',
      'itemModifiersByGroupSubGroup',
      'modifiersInSubgroup',
      'brandStoreRoute',
      'brandStoreParams',
    ]),
  },
  props: ['addToCartAction'],
  components: {QtyBox},
  methods: {
    ...mapActions(['addItemToCart']),
    buyNow() {
      this.addToCart('buynow')
      this.$router.push({
        name: this.brandStoreRoute('cart'),
        params: {
          ...this.brandStoreParams
        },
      })
    },
    addToCart() {
      let item = { ...this.$store.state.cart_store.selectedItem }
      // this.$store.dispatch('resolveProduct')
      //attach modifiers here
      //match item store id with the cart item store id
      //if not matched set warning
      let cartStoreId = undefined
      let cartBrandId = undefined
      if (this.$store.getters.cart_items_count) {
        cartStoreId = this.$store.getters.cart_items[0].store_id
        cartBrandId = this.$store.getters.cart_items[0].brand_id
      }

      item.modifiers = this.selected_modifiers
      if (this.validateModifiersSelection()) {
        // if (cartStoreId && this.$store.getters.currentStoreId !== cartStoreId) {
        //   let warn = 1
        //   if (this.$store.getters.currentBrandId !== cartBrandId) {
        //     warn = 2
        //   }
        //   this.$store.commit('STORE_CHANGE_WARN', warn)
        // } else {
          this.addItemToCart(item)
          this.$router.push({
            // name: this.brandStoreRoute('cart'),
            name: this.brandStoreRoute('store_page'),
            params: {
              ...this.brandStoreParams,
            },
          })
          this.$store.commit('SET_ITEM_DETAIL_POPUP', false)
          document.body.classList.remove('body-overlay')
        //}
      }
    },
    validateModifiersSelection() {
      this.errors = {}
      //find in subgroups if it is mandatory then its subgroup id should be found in selected_modifiers
      this.itemModifierGroups(this.item).forEach(group => {
        this.itemModifierSubgroupsByGroup(group).forEach(subgroup => {
          if (this.modifiersInSubgroup(group, subgroup)) {
            if (subgroup.item_type == 'mandatory') {
              if (
                !this.selected_modifiers.some(
                  mod => mod.modifier_sub_group == subgroup._id
                )
              ) {
                //this.errors[subgroup._id] = this._T(`Please select at least one modfiier from '${this._T_DB(subgroup, 'name')}'`)
                this.errors[subgroup._id] = this._T(
                  `Please select at least one`
                )
              } else {
                const totalModifiersInSubgroup = this.itemModifiersByGroupSubGroup(
                  group,
                  subgroup
                ).length
                let totalAllowed =
                  subgroup.no_of_selection > totalModifiersInSubgroup
                    ? totalModifiersInSubgroup
                    : subgroup.no_of_selection
                if (
                  totalAllowed !=
                  this.selected_modifiers.filter(
                    mod => mod.modifier_sub_group == subgroup._id
                  ).length
                ) {
                  this.errors[subgroup._id] = this._T(
                    `Please select ${totalAllowed}`
                  )
                }
              }
            }
          }
        })
      })
      this.$store.commit('MODIFIER_ERRORS', this.errors)
      return isObjectEmpty(this.errors)
    },
    addToItem() {
      let item = { ...this.$store.state.cart_store.selectedItem }
      //attach modifiers here
      item.modifiers = this.selected_modifiers
      // this.$store.commit('SET_ITEM_DETAIL_POPUP', false)
      this.$bvModal.hide('combo-modifiers')
      this.$store.commit('combo_items_store/SET_MODIFIERS', item, {
        root: true,
      })
      this.$store.commit('SELECT_MODIFIERS', {})
    },
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .product-page {
    .btn-solid {
      margin-right: auto;
      margin-left: unset;
    }
  }
}
.modifier-side-popup {
  &.open-popup {
    .modal-bottom {
      right: 0px !important;
    }
  }
}
.product-page {
  background: $white;
  box-shadow: 0px -$px4 $px34 rgba($black, 0.07);
  padding: $px12 0;

  //max-width: $px600;
  width: 100%;
  //right: -$px600 !important;
  transition: opacity 0.3s linear, right 0.3s ease-out !important;
  .btn-solid {
    &:hover,
    &:focus {
      .content {
        border-color: $color-primary;
        .name,
        .price {
          color: $color-primary;
        }
      }
    }
  }
  display: flex;
  align-items: center;
  .qty-title {
    font-weight: normal;
    font-size: $px14;
    line-height: $px22;
    letter-spacing: 0.5px;
    color: $font-color;
    margin-bottom: 0;
    text-transform: capitalize;
  }
  .btn-solid {
    margin-left: auto;
    text-transform: capitalize;
    svg,
    img {
      margin-right: $px12;
    }
    &:hover {
      svg {
        path {
          fill: $color-primary !important;
        }
      }
    }
  }
}
@media (max-width: 1367px) {
  .product-page {
    //right: -$px500 !important;
    //width: $px500 !important;
    //max-width: $px500 !important;
  }
}
@media (max-width: 1024px) {
  .qty-title {
    display: none;
  }
  .qty-box {
    margin-left: unset;
  }
}
@media (max-width: 575px) {
  .qty-title {
    display: none;
  }
  .qty-box {
    margin-left: unset;
  }
  .product-page {
    z-index: 2;
    position: fixed;
    //width: 100% !important;
    max-width: 100% !important;
    bottom: $px52;
    padding:$px12 $px6;
    left:0;
  }
}
</style>
